// extracted by mini-css-extract-plugin
module.exports = {"mainList":"_1LqyHSRBRcFLlT5WcKN-nO","link":"_1fPD9fBnikWgRmecSO96By","active":"Cwx_Z8FzW824YhLLK0a5g","list":"Qj5ckDLfx1GUtzoKM5mSJ"};